<template>
  <div class="main">
    <Header
      :show="true"
      title="人员预约审核"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div class="content">
      <van-cell-group>
        <van-field
          v-model.trim="listQuery.data.name"
          label="访客名称"
          placeholder="请输入"
        />
        <van-cell
          :value="statusDate"
          is-link
          title="时间区间"
          @click="listQuery.showStatusDatePick = true"
        />
        <van-calendar
          v-model="listQuery.showStatusDatePick"
          type="range"
          :default-date="listQuery.data.date"
          color="#ee0a24"
          :min-date="listQuery.minDate"
          :max-date="listQuery.maxDate"
          :style="{ 'padding-bottom': '30px' }"
          @confirm="onConfirmDateChoose"
        />

        <van-cell
          :value="statusQueryName"
          is-link
          title="审核状态"
          @click="listQuery.showStatusActionSheet = true"
        />
        <van-action-sheet
          v-model="listQuery.showStatusActionSheet"
          :actions="listQuery.statusList"
          cancel-text="取消"
          description="请选择待查询的检测状态"
          @select="onStatusQueryChoose"
        />
      </van-cell-group>
      <div style="padding: 16px">
        <van-button
          round
          block
          type="info"
          :loading="table.loading"
          @click="handleQuery"
        >
          查询
        </van-button>
      </div>
      <el-table
        ref="table"
        :loading="table.loading"
        :data="table.data"
        style="width: 100%"
        row-key="id"
        @row-click="onTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              class="table-expand-form"
            >
              <el-form-item label="访客姓名">
                <span>{{ row.name }}</span>
              </el-form-item>
              <el-form-item label="电话号码">
                <span>{{ row.phone }}</span>
              </el-form-item>
              <el-form-item label="访问事由">
                <span>{{ row.reason }}</span>
              </el-form-item>
              <el-form-item label="预约区域">
                <span>{{ row.gate }}</span>
              </el-form-item>
              <el-form-item label="访客照片">
                <van-image
                  width="100px"
                  height="100px"
                  :src="row.avatarUrl"
                  @click="handleClickPreview(row.avatarUrl)"
                >
                  <template #index>
                    访客照片
                  </template>
                </van-image>
              </el-form-item>
              <el-form-item label="开始时间">
                <span>{{ row.startDate | formatDate }}</span>
              </el-form-item>
              <el-form-item label="结束时间">
                <span>{{ row.endDate | formatDate }}</span>
              </el-form-item>
              <el-form-item label="审核状态">
                <el-tag
                  v-if="row.audit === 0"
                  type="info"
                >
                  未审核
                </el-tag>
                <el-tag
                  v-else-if="row.audit === 1"
                  type="success"
                >
                  已审核
                </el-tag>
                <el-tag
                  v-else-if="row.audit === -1"
                  type="danger"
                >
                  未通过
                </el-tag>
              </el-form-item>
              <el-form-item
                v-if="checkPermission([512])"
                label="操作"
              >
                <el-button
                  :disabled="row.auditStatus !== 0"
                  type="primary"
                  size="small"
                  @click="handleAllow(row)"
                >
                  允许
                </el-button>
                <el-button
                  :disabled="row.auditStatus !== 0"
                  type="danger"
                  size="small"
                  @click="handleDeny(row)"
                >
                  拒绝
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="访客姓名"
          props="name"
          align="center"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.name }}
          </template>
        </el-table-column>
        <el-table-column
          label="联系电话"
          props="phone"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.phone }}
          </template>
        </el-table-column>
        <el-table-column
          label="审核状态"
          prop="audit"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.audit === 0"
              type="info"
            >
              未审核
            </el-tag>
            <el-tag
              v-else-if="row.audit === 1"
              type="success"
            >
              已审核
            </el-tag>
            <el-tag
              v-else-if="row.audit === -1"
              type="danger"
            >
              未通过
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="handleQuery"
      />
    </div>
    <Footer value="service" />
  </div>
</template>
<script>
import { Dialog, ImagePreview } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { getList, check } from "@/api/visitor-reservation";

import dayjs from "dayjs";

export default {
  filters: {
    formatDate(val) {
      if (!val) return val;
      return dayjs(val).format("YYYY-MM-DD");
    },
  },
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      listQuery: {
        limit: 10,
        page: 1,
        data: {
          name: "",
          auditStatus: "",
          date: [
            dayjs().startOf("months").toDate(),
            dayjs().endOf("months").toDate(),
          ],
        },
        minDate: dayjs("2010-01-01").toDate(),
        maxDate: dayjs("2100-01-01").toDate(),
        showStatusActionSheet: false,
        showStatusDatePick: false,
        statusList: [
          { name: "全部", value: "" },
          { name: "未审核", value: 0 },
          { name: "已审核", value: 1 },
          { name: "未通过", value: -1 },
        ],
      },
      returnConcreteId: "",
      showReturnConcrete: false,
      table: {
        loading: false,
        key: "table",
        total: 0,
        data: [],
      },
    };
  },
  computed: {
    statusQueryName() {
      const {
        data: { auditStatus },
        statusList,
      } = this.listQuery;

      return statusList.find((st) => st.value === auditStatus)?.name;
    },
    statusDate() {
      const {
        data: { date },
      } = this.listQuery;

      return `${dayjs(date[0]).format("YYYY-MM-DD")} ~ ${dayjs(date[1]).format(
        "YYYY-MM-DD"
      )}`;
    },
  },
  created() {
    this.handleQuery();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    onConfirmDateChoose(value) {
      this.listQuery.data.date = value;
      this.listQuery.showStatusDatePick = false;
    },
    handleQuery() {
      const { limit, page, data } = this.listQuery;
      const payload = { ...data, size: limit, page };
      this.table.loading = true;
      getList(payload)
        .then(({ data }) => {
          const {
            data: { total, records },
          } = data;

          this.table.data = records;
          this.table.total = total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    onDateQueryChoose(val) {
      this.listQuery.data.date = val;
      this.listQuery.showCalendar = false;
    },
    onStatusQueryChoose(val) {
      this.listQuery.data.auditStatus = val.value;
      this.listQuery.showStatusActionSheet = false;
      this.handleQuery();
    },
    onTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickPreview(url) {
      ImagePreview([url]);
    },
    handleClickUpdate(row) {
      this.$router.push({
        path: "/service/business/owdr/create",
        query: row,
      });
    },
    async handleAllow(row) {
      await Dialog.confirm({
        title: "允许访问",
        message: `是否通过区域: ${row.gate} 的访问申请？`,
      });
      const payload = {
        id: row.id,
        yesOrNo: "0",
        rejectReason: "",
      };
      const { data } = await check(payload);
      if (
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          data.code,
          "通过预约申请",
          data.msg
        )
      ) {
        this.handleQuery();
      }
    },
    async handleDeny(row) {
      await Dialog.confirm({
        title: "拒绝访问",
        message: `是否拒绝区域: ${row.gate} 的访问申请？`,
      });

      const payload = {
        id: row.id,
        yesOrNo: "1",
        rejectReason: "",
      };
      const { data } = await check(payload);
      if (
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          data.code,
          "拒绝预约申请",
          data.msg
        )
      ) {
        this.handleQuery();
      }
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell__title {
  max-width: 30%;
  font-size: 2vh;
}
::v-deep .van-cell__value {
  max-width: 70%;
}
.content {
  padding-bottom: 80px;
}
.table-expand-form {
  padding: 0 12px;

  .el-form-item {
    margin: 4px 0px;
  }
}
</style>
